import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { issuesArchivedGetSlice } from './get';

export const issuesArchivedReducers = combineReducers({
	get: issuesArchivedGetSlice.asyncReducers
});

export const issuesArchivedWatchers = combineAllWatchers([ issuesArchivedGetSlice.asyncWatchers ]);
